import MenuUser from './MenuUser'

export default MenuUser
// eslint-disable-next-line import/export
export * from './MenuUser'
